module.exports = __webpack_public_path__ + "media/Jim-Yosef-Cant-Wait.38c3d77f.mp3";